import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import Button from "../UI/Button";
import { BorderButton } from "../UI/BorderButton";
import CupPointIcon from "../../public/img/mall/cup-point.svg";
import HolderIcon from "../../public/img/mall/holder.svg";
import classNames from "classnames";
import { formatThousand } from "utils";
import { useRouter } from "next/router";
import { Tag2 } from "./tag";
import { translate } from "@/utils/i18n";
import dayjs from "dayjs";

const BuyBtn = ({ item, ...restProps }) => {
  const { t } = useTranslation("mall");

  return (
    <BorderButton size="l" className="w-full" {...restProps}>
      <div className="w-full flex justify-between font-black">
        <div>{t("cuppoints")}</div>
        <div className="flex items-center">
          <CupPointIcon />
          <span className="leading-none">{formatThousand(item.cupPoints)}</span>
        </div>
      </div>
    </BorderButton>
  );
};

const ComingSoonBtn = () => {
  const { t } = useTranslation("mall");
  return (
    <BorderButton size="l" className="w-full" disabled>
      {t("comingsoon")}
    </BorderButton>
  );
};

export const Item = ({ item, index, onItemClick }) => {
  const { t } = useTranslation("mall");
  const { locale } = useRouter();

  const title = locale === "cn" ? item.goodsName : item.overseaName;
  const desc = locale === "cn" ? item.desc : item.overseaDesc;

  const timeLimit =
    +item.limitTime <= 0 ? undefined : dayjs(item.limitTime * 1000);

  return (
    <div
      className={classNames(
        "border-2 border-solid border-white rounded-[40px] p-[24px] pt-[40px] mb-[24px] relative cursor-pointer btn-item",
        index % 3 === 0 ? "ml-0" : "ml-[24px]"
      )}
      style={{ width: "calc((100% - 48px) / 3)" }}
      data-event="mall_goods_click"
      onClick={() => {
        onItemClick(item);
      }}
    >
      <div className="h-[112px]">
        <div
          className="font-black text-[24px] leading-[28px] mb-[8px] line-clamp-1"
          title={title}
        >
          {title}
        </div>

        <div>
          {item.showStorageLabel && (
            <Tag2>
              {+item.goodsStat.total === 0
                ? t("soldout")
                : translate(t("itemCount"), { count: item.goodsStat.total })}
            </Tag2>
          )}

          {timeLimit && (
            <Tag2>
              {translate(t("itemTimeLimit"), {
                time:
                  locale === "cn"
                    ? timeLimit.format("YYYY.MM.DD")
                    : timeLimit.format("MMMM DD, YYYY"),
              })}
            </Tag2>
          )}
        </div>

        <div
          className="text-[14px] font-normal leading-[22px] line-clamp-2"
          dangerouslySetInnerHTML={{ __html: desc }}
        ></div>
      </div>

      <div className="mt-[16px] mb-[24px]">
        <div className="aspect-w-1 aspect-h-1 relative">
          <Image
            src={item.mainPic}
            layout="fill"
            alt=""
            className="transition hover:scale-125"
          />
        </div>
      </div>

      <div>
        {/* <ComingSoonBtn /> */}
        <BuyBtn item={item} />
      </div>

      {item.onlyHolder && (
        <div className="absolute right-[-40px] top-[-40px]">
          <HolderIcon />
        </div>
      )}
    </div>
  );
};
